import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action


export const fetchSaleOrdTrackingData = createAsyncThunk('fetchSaleOrdTrackingData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getSaleOrderTracking`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const trackingSlice = createSlice({
    name: 'AllTrackingData',
    initialState: {
        isLoading: false,
        sotrack: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchSaleOrdTrackingData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSaleOrdTrackingData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.sotrack = action.payload;
        });
        builder.addCase(fetchSaleOrdTrackingData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });




    }
});

export default trackingSlice.reducer;
